export default {
      id: "output_-usage",
      viewBox: "0 0 35 34",
      url: __webpack_public_path__ + "img/icons.svg#output_",
      toString: function () {
        return this.url;
      }
    }